<template>
  <div>
    <v-form>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap py-0>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">Cari Hareket Düzenle</v-toolbar-title>
              <v-spacer></v-spacer>


              <v-btn @click="carihareketGuncelle()" flat> <span class="hidden-sm-and-down"> Güncelle </span>
                <v-icon right dark>create</v-icon>
              </v-btn>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="carihareketSil()">
                    <v-list-tile-title>Cari Hareket Sil</v-list-tile-title>
                  </v-list-tile>

                  <a target="_self" v-bind:href="'#/carihareketler/index'">
                    <v-list-tile>
                      <v-list-tile-title>İptal</v-list-tile-title>
                    </v-list-tile>
                  </a>
                </v-list>
              </v-menu>


            </v-toolbar>
          </v-flex>

          <v-flex pa-1 xs12 sm12 md4>
            <v-card class="white--text">
              <v-card color="grey lighten-4" flat="">
                <v-card-actions>
                  <v-layout justify-space-between column>
                    <v-form ref="formbiletrapor" v-model="valid" lazy-validation>
                      <v-autocomplete hide-details append-icon="search" label="Cari Seçiniz" :loading="loading" :items="statecari"
                        clearable="" item-text="text" cache-items="" item-value="id" :search-input.sync="search"
                        v-model="Movement.Current" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></v-autocomplete>

                      <tarihcomp :etiket="'Tarih'" :detaygizle="true" v-model="Movement.MovementDate" :rules="[v => !!v || 'Lütfen tarih seçiniz']" v-bind:defaultvalue="'ok'"></tarihcomp>

                      <tarihcomp :etiket="'Vade Tarihi'" :detaygizle="true" v-model="Movement.MovementDueDate"   v-bind:defaultvalue="'ok'"></tarihcomp>
                      <v-autocomplete :items="EvrakTipi1" :rules="[v => !!v || 'Lütfen seçiniz']" hide-details="" v-bind="EvrakTipi1" item-text="Title"
                        clearable item-value="Evrakkod" v-model="Movement.DocumentType" label="Evrak Tipi"></v-autocomplete>
                      <v-text-field hide-details="" @blur="makbuztipkontrol()" rows="10px" label="Evrak No" v-model="Movement.DocumentNumber">
                      </v-text-field>
                      <v-select :items="states1" hide-details="" label="Borç/Alacak" item-text="text" item-value="id"
                        v-model="Movement.DebitCredit" :rules="[v => !!v || 'Lütfen seçiniz']" clearable></v-select>
                    </v-form>
                    <parainput :name="tutar" :error-messages="errors.collect('tutar')" v-model="Movement.Amount"
                      :etiket="etikettutar" data-vv-name="tutar" required v-validate="'required'" :id="tutar"
                      :autocomplete="autocomplete"></parainput>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>

          <v-flex pa-1 xs12 sm12 md4>
            <v-card class="white--text">
              <v-card color="grey lighten-4" flat="">
                <v-card-actions>
                  <v-layout justify-space-between column>

                    <v-autocomplete :items="masrafmerkezi" hide-details="" label="Masraf Merkezi" item-text="CodeName"
                      clearable v-model="Movement.ExpenseCenter" item-value="Code"></v-autocomplete>




                    <v-autocomplete hide-details="" :items="Referans" label="Referans" v-model="Movement.Reference"
                      clearable item-text="ReferansAd" item-value="Kod"></v-autocomplete>

                    <v-select hide-details="" :items="makbuztipi" @select="evraktipkontrol()" label="Makbuz Tipi"
                      clearable item-text="text" v-model="Movement.ReceiptType" item-value="value"></v-select>

                    <v-textarea label="Açıklama" v-model="Movement.Explanation" value=""></v-textarea>

                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>

          <v-flex pa-1 xs12 sm12 md4>
            <v-card class="white--text">
              <v-card color="grey lighten-4" flat="">
                <v-card-actions>
                  <v-layout justify-space-between column>
                    <v-autocomplete :items="doviztipi" item-text="DovizUnvan" @change="kurgetir(Movement.ExchangeType)"
                      item-value="DovizKod" hide-details="" v-model="Movement.ExchangeType" label="Döviz Tipi"
                      clearable></v-autocomplete>
                    <dovizinput v-model="Movement.ExchangeRate" :etiket="'Döviz Kur Tutar'" :autocomplete="autocomplete"></dovizinput>
                    <dovizinput :name="doviztutar" v-model="Movement.ExchangeAmount" :etiket="etiketdoviztutar" :id="doviztutar"
                      :autocomplete="autocomplete"></dovizinput>

                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>


          <v-layout v-if="karsicari" row="" wrap="">
            <v-flex xs12 sm12 md12>

              <div v-if="karsicari">

                <v-card flat="" color="#9E9E9E">
                  <v-card-title>
                    <span class="subheading white--text font-weight-medium "> Karşı Hareket Bilgileri</span>
                  </v-card-title>
                </v-card>
              </div>
            </v-flex>

            <v-flex pa-1 xs12 sm12 md4>
              <v-card class="white--text">
                <v-card color="grey lighten-4" flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>


                      <v-autocomplete hide-details clearable label="Karşı Cari Seçiniz" autocomplete append-icon="search"
                        :loading="loading" :items="statecari2" item-text="text" cache-items="" item-value="id"
                        :search-input.sync="search1" v-model="Movement.ContraCurrent"></v-autocomplete>


                      <v-autocomplete :items="EvrakTipi2" clearable hide-details="" v-model="Movement.ContraDocumentType"
                        v-bind="EvrakTipi2" item-text="Aciklama" item-value="Evrakkod" label=" Karşı Evrak Tipi"></v-autocomplete>

                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>

            </v-flex>


            <v-flex pa-1 xs12 sm12 md4>
              <v-card class="white--text">
                <v-card color="grey lighten-4" flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>
                      <v-textarea label=" Karşı Açıklama" v-model="Movement.ContraExplanation" value=""></v-textarea>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>
            <v-flex pa-1 xs12 sm12 md4>
              <v-card class="white--text">
                <v-card color="grey lighten-4" flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>
                      <v-autocomplete hide-details="" @change="kurgetir1(Movement.ContraExchangeType)" :items="doviztipi"
                        item-text="DovizUnvan" item-value="DovizKod" clearable label=" Karşı Döviz Tipi" v-model="Movement.ContraExchangeType"></v-autocomplete>

                      <dovizinput v-model="Movement.ContraExchangeRate" :etiket="'Döviz Kur Tutar'" :autocomplete="autocomplete"></dovizinput>

                      <dovizinput :name="karsidoviztutar" v-model="Movement.ContraExchangeAmount" :etiket="karsietiktutar"
                        :id="karsidoviztutar" :autocomplete="autocomplete"></dovizinput>

                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

          </v-layout>


        </v-layout>
      </v-card>
    </v-form>
    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
          :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'

  import parainput from '../customcomp/parainput'
  import dovizinput from '@/components/app/customcomp/dovizinput.vue'


  export default {

    props: {
      carikod: ''
    },


    data() {
      return {
        drawer: null,
        baslik: '',
        e1: 0,
        Code: '',
        e2: true,
        rules: {
          required: (value) => !!value || 'Gerekli alan.',
          email: (value) => {
            const pattern =
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Hatalı e-mail.'
          }
        },
        valid: true,
        loading: false,
        search: '',
        search1: '',
        karsicari: false,
        statecari: [],
        statecari2: [],
        masrafmerkezi: [],
        Referans: [],
        states1: [{
            id: 'A',
            text: 'Alacak'
          },
          {
            id: 'B',
            text: 'Borç'
          },
        ],
        doviztipi: [],
        EvrakTipi1: [],
        EvrakTipi2: [],
        items1: [],
        Movement: {
          Current: '',
          ContraCurrent: 0,
          MovementDate: null,
          MovementDueDate: null,
          DocumentType: '',
          DocumentNumber: '',
          Explanation: '',
          DebitCredit: '',
          Amount: 0,
          ExchangeType: '',
          ExchangeRate: 0,
          ExchangeAmount: 0,
          ContraDocumentType: '',
          ContraDocumentNumber: '',
          ContraExplanation: '',
          ContraExchangeType: '',
          ContraExchangeRate: 0,
          ContraExchangeAmount: 0,
          CompanyCode: '',
          SiraNo: '',
          OrderNumber: '',
          ExpenseCenter: '',
          Reference: '',
          DefinationID: 0,
          InstallmentID: '',
          PaymentCode: '',
          ReceiptType: '',
        },
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,

        autocomplete: 'autocomplete',
        tutar: 'tutar',
        etikettutar: 'Tutar',

        doviztutar: 'doviztutar',
        etiketdoviztutar: 'Döviz Tutar',

        kurtutar: 'kurtutar',
        etiketkurtutar: 'Döviz Kuru',


        karsikurtutar: 'karsikurtutar',
        karsietiketkurtutar: 'Karşı Döviz Kuru',


        karsidoviztutar: 'karsidoviztutar',
        karsietiktutar: 'Karşı Döviz Tutar',
        makbuztipi: [{
            text: 'Yok',
            value: '0'
          },
          {
            text: 'Tahsil',
            value: '1'
          },
          {
            text: 'Tediye',
            value: '2'
          }
        ],

        dictionary: {
          custom: {
            carikod: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            tarih: {
              required: () => 'Bu alan boş bırakılamaz',
            },
          }
        }
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {

      kurgetir(kod) {
        var params1 = {
          Tarih: getDateNow(),
          DovizKod: kod
        }
        this.$http.post(auth.API_URL + 'api/Helpers/GetRate', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.Movement.ExchangeRate = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Kur Hesapla'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Kur Hesapla'
            this.snackbar = true
          }
        })
      },
      kurgetir1(kod) {
        var params1 = {
          Tarih: getDateNow(),
          DovizKod: kod
        }
        this.$http.post(auth.API_URL + 'api/Helpers/GetRate', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.Movement.ContraExchangeRate = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Kur Hesapla'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Kur Hesapla'
            this.snackbar = true
          }
        })
      },
      carigetir: carigetir,
      carigetir1: carigetir1,
      carihareketGuncelle: carihareketGuncelle,
      carihareketSil: carihareketSil,
      toDate: toDate,
      toDateformat: toDateformat,
      wait: wait,
      formatMoney: formatMoney,
    },
    beforeMount: beforeMount,
    components: {
      'parainput': parainput,
      dovizinput,
      tarihcomp
    },
    watch: {
      search(val) {
        val && this.carigetir(val)
      },
      search1(val2) {
        val2 && this.carigetir1(val2)
      }
    },
  }



  function formatMoney(n) {
    return parseFloat(n).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1.').replace(/\.(\d+)$/, ',$1');
  }



  function carigetir(v) {
    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari = response.body

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }

  function carigetir1(v) {
    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari2 = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Cari'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Cari'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }


  function beforeMount() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }


    this.$http.post(auth.API_URL + 'api/currency/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      }
    })





    this.$http.post(auth.API_URL + 'api/doctype/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.EvrakTipi1 = response.body
      this.EvrakTipi2 = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Evrak Tipi'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Evrak Tipi'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Masraf Merkezi'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Masraf Merkezi'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/Reference/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.Referans = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Referans'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Referans'
        this.snackbar = true
      }
    })







    var GetMovement = {
      CompanyCode: credentials.SirketKodu,
      Date: this.$route.query.dt,
      AccountCode: this.$route.query.ac,
      OrderNumber: this.$route.query.on
    }



    this.$http.post(auth.API_URL + 'api/CurrentMovement/Get', GetMovement, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      var seciliitems = [{
        text: response.body.Cari.Unvan + '-' + response.body.Cari.Kod,
        id: response.body.Cari.Kod
      }]
      this.statecari = seciliitems
      this.Movement.Current = response.body.Cari.Kod

      this.Movement.MovementDate = response.body.Tarih
      this.Movement.MovementDueDate = response.body.Vade
      this.Movement.DocumentType = response.body.Evrak.Evrakkod
      this.Movement.DocumentNumber = response.body.Evrakno
      this.Movement.Explanation = response.body.Aciklama
      this.Movement.DebitCredit = String(response.body.BA)
      this.Movement.Amount = response.body.Tutar
      this.Movement.ReceiptType = String(response.body.MakbuzTip)
      this.Movement.InstallmentID = response.body.TaksitRef
      this.Movement.DefinationID = response.body.TanimID
      this.Movement.PaymentCode = response.body.OdemeKod

      this.Movement.ExchangeType = response.body.DovizCinsi
      this.Movement.ExpenseCenter = response.body.Masraf.Code
      this.Movement.SiraNo = response.body.Sirano
      this.Movement.Reference = response.body.Referans.Kod
      this.Movement.ExchangeRate = response.body.Kur
      this.Movement.ExchangeAmount = response.body.DovizTutar

      if (response.body.KarsiCari != '') {
        this.Movement.ContraCurrent = response.body.KarsiCari
        this.search1 = this.Movement.ContraCurrent
        this.Movement.ContraDocumentType = response.body.KarsiEvrak
        this.Movement.ContraExplanation = response.body.KarsiAciklama
        this.Movement.ContraExchangeType = response.body.KarsiDovizTip
        this.Movement.ContraExchangeRate = response.body.KarsiKur
        this.Movement.ContraExchangeAmount = response.body.KarsiDovizTutar
        this.karsicari = true

      } else {
        this.karsicari = false
      }


    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

  }

  function toDateformat(dateStr) {


    var parts = dateStr.split("-");
    return (parts[2] + '.' + parts[1] + '.' + parts[0]);
  }

  function toDate(dateStr) {
    var parts = dateStr[0].split("-");
    return (parts[2] + '.' + parts[1] + '.' + parts[0]);
  }

  function carihareketGuncelle() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (this.$refs.formbiletrapor.validate()) {
      var currentMovement = this.Movement

      currentMovement['CompanyCode'] = credentials.SirketKodu
      currentMovement['OrderNumber'] = this.Movement.SiraNo
      this.$http.post(auth.API_URL + 'api/CurrentMovement/Update', currentMovement, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status === true) {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
        } else {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })
    }
  }

  function wait(ms) {
    var d = new Date();
    var d2 = null;
    do {
      d2 = new Date();
    }
    while (d2 - d < ms);
  }

  function carihareketSil() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (window.confirm('Cari Hareketi silmek istediğinizden emin misiniz?')) {
      console.log(this.Movement.DefinationID)

      var currentMovement = {
        AccountCode: this.Movement.Current,
        CompanyCode: credentials.SirketKodu,
        Date: this.Movement.MovementDate,
        OrderNumber: this.Movement.SiraNo,
        DefinationID: this.Movement.DefinationID,
        InstallmentID: this.Movement.InstallmentID,
        PaymentCode: this.Movement.PaymentCode
      }

      this.$http.post(auth.API_URL + 'api/CurrentMovement/Delete', currentMovement, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status === true) {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
          wait(2000);
          var url = '#/carihareketler/index'
          window.open(url, '_target')

        } else {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })
    }
  }
</script>

<style>
</style>